import NotImplementedError from "./NotImplementedError.js";

/**
 *
 * @version 2026-09-03
 * @author Patrik Harag
 */
export default class DataProvider {

    // filters

    hasStoredFilters() {
        throw new NotImplementedError();
    }

    /**
     *
     * @return Promise<string>
     */
    fetchFilters() {
        throw new NotImplementedError();
    }

    /**
     *
     * @return Promise
     */
    storeFilters(rawFilters) {
        throw new NotImplementedError();
    }

    discardFilters() {
        throw new NotImplementedError();
    }

    // datasets

    hasStoredDatasets() {
        throw new NotImplementedError();
    }

    /**
     * @returns Promise<Map<Dataset>>
     */
    fetchDatasets() {
        throw new NotImplementedError();
    }

    /**
     *
     * @return Promise
     */
    storeDatasets(datasets) {
        throw new NotImplementedError();
    }

    discardDatasets() {
        throw new NotImplementedError();
    }

    // fx rates

    supportsFxFetch() {
        return false;
    }

    /**
     * @param currencies {string[]}
     * @return {Promise<object[]>}
     */
    fetchFxRates(currencies) {
        throw new NotImplementedError();
    }
}

